import Button from './Button';
export { ButtonType } from './Button';

import './Button.scss';

export default Button;
